"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reportWebVitals = reportWebVitals;
var _logger = require("@ori/logger");
var _logger2 = require("../logger");
const logger = _logger2.mainLogger.createChild('reportWebVitals');
async function reportWebVitals({
  value,
  name
}) {
  const roundedValue = Number(value.toFixed(3));
  if (!_logger.ApplicationInsights.isInitialized()) {
    _logger.ApplicationInsights.initialize(global.oriAppInsightsSettings);
  }
  logger.metric(name, roundedValue);
  if (window.ori?.developmentInfo) {
    window.ori.developmentInfo.performanceMetrics = {
      ...window.ori.developmentInfo.performanceMetrics,
      [name]: roundedValue
    };
  }
}
